import React from "react";
import {LoadingDialog} from "../../../../components/DialogLoading";

export const RobotManagementDialog = () => ({
  loading: <LoadingDialog label="載入中"/>,
})
